export const ConnectorTypes = {
    ACTIVE_DIRECTORY: 'activedirectory',
    AZURE_ACTIVE_DIRECTORY: 'azureactivedirectory',
};

export const ActionTypes = {
    NONE: 'none',
    VIEW: 'view',
    DETAILS: 'details',
    RESET: 'reset',
    RELOAD: 'reload',
    INSTALL: 'install',
    EDIT: 'edit',
    REMOVE: 'remove',
    REMOVE_CONFIRMED: 'remove.confirmed',
    CREATE_NEW: 'create.new',
    CREATE_NEW_CONFIRMED: 'create.new.confrimed',
    UPDATE_EXTRA: 'update.connector.extra',
    SYNCHRONIZE: 'synchronize',
    REDIRECT: 'redirect',
};

const BRAND_LEARN_MORE_URLS = {
    activedirectory: 'active_directory_connector_learn_more_url',
    azureactivedirectory: 'azure_active_directory_connector_learn_more_url',
};

export const getLearnMoreUrl = identifier => BRAND_LEARN_MORE_URLS[identifier];

export const isValidConnector = connector => {
    if (isAzureConnector(connector)) {
        return isValidAzureConnector(connector);
    }
    return true;
};

export const isValidAzureConnector = connector =>
    isCompleteAzureConnector(connector) && isVerifiedAzureConnector(connector);

export const isAzureConnector = connector =>
    connector.identifier === ConnectorTypes.AZURE_ACTIVE_DIRECTORY;

export const isActiveDirectory = connector =>
    connector.identifier === ConnectorTypes.ACTIVE_DIRECTORY;

export const isCompleteAzureConnector = ({ extra }) => !!(extra && extra.group);

export const isVerifiedAzureConnector = ({ extra }) => !!extra.is_verified;

export const isAvaliableToSync = ({ extra }) => !!extra.is_available;
